import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import RtlLayout from "layouts/rtl";
import SignIn from "views/auth/SignIn";
import { AuthProvider } from "context/AuthContext";
import ProtectedRoute from "components/ProtectedRoute";
import { ServicesProvider } from "views/admin/Services/ServicesContext";
import SingleOrder from "views/admin/payment_admin/orderDetails";
import OrderDetails from "views/admin/tables/single_order";
import RunnerDetails from "views/admin/tables/runner_details";
import UserDetails from "views/admin/marketplace/view"; 
import UserDetailsRunner from "views/admin/runnerboys/view";
import EditUser from "views/admin/marketplace/Edit_User";
import EditRunner from "views/admin/runnerboys/Edit_Runner";
const App = () => {
  return (
    <AuthProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            borderRadius: "12px",
            padding: "14px 20px",
            fontSize: "14px",
            fontWeight: "500",
          },
          success: {
            style: { background: "#10b981", color: "#fff" },
            iconTheme: { primary: "#fff", secondary: "#10b981" },
          },
          error: {
            style: { background: "#ef4444", color: "#fff" },
            iconTheme: { primary: "#fff", secondary: "#ef4444" },
          },
        }}
      />
      <Routes>
        {/* Public auth routes */}
        <Route path="auth/signin" element={<SignIn />} />
        <Route path="auth/*" element={<AuthLayout />} />

        {/* Protected admin routes */}
        <Route
          path="admin/*"
          element={
            <ProtectedRoute allowedRoles={["SA", "A", "R"]}>
              <ServicesProvider>
                <AdminLayout />
              </ServicesProvider>
            </ProtectedRoute>
          }
        />

        <Route path="/booking/:orderId" element={<SingleOrder />} />
        <Route path="/orders/:id" element={<OrderDetails />} />
        <Route path="/runner/:runnerId" element={<RunnerDetails />} />
        <Route path="/user_details/:id" element={<UserDetails />} />
        <Route path="/runner_details/:id" element={<UserDetailsRunner />} />
        <Route path="/edit_user/:id" element={<EditUser />} />
        <Route path="/edit_runner/:id" element={<EditRunner />} />
        
        {/* RTL layout */}
        <Route path="rtl/*" element={<RtlLayout />} />


        {/* Default redirect to sign in */}
        <Route path="/" element={<Navigate to="auth/signin" replace />} />
      </Routes>
    </AuthProvider>
  );
};

export default App;
